import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "alert_host",
  "use": "alert_host-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"alert_host\"><g fill-rule=\"evenodd\"><path d=\"M15 11a1 1 0 01-1 1H2a1 1 0 01-1-1V2a1 1 0 011-1h12a1 1 0 011 1v9zM14 0H2C.897 0 0 .897 0 2v9c0 1.103.897 2 2 2h4v2H3.5a.5.5 0 000 1h9a.5.5 0 000-1H10v-2h4c1.103 0 2-.897 2-2V2c0-1.103-.897-2-2-2z\" /><path d=\"M7.5 8h1V4h-1v4zm0 2h1V9h-1v1zM2 11h12L8 2l-6 9z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id